<template>
  <v-card>
    <v-card-title>
      <app-title headline>
        <slot></slot>
      </app-title>
    </v-card-title>
    <v-card-text>
      <v-container fluid></v-container>

      <v-data-table
        :headers="headers"
        :items="customers"
        loading="true"
        class="elevation-1"
        pagination.sync="pagination"
        item-key="id"
        :show-select="selection"
        v-model="selected"
        :search="search"
        :single-select="false"
        @item-selected="selectRecord"
      >
        <template v-slot:top>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="refresh">Refresh</v-btn>
          <v-btn
            v-if="selection"
            @click="deleteRecord"
            class="error"
            :disabled="selected.length==0"
          >Delete Entries</v-btn>
          <v-btn
            v-if="selection"
            @click="suppressRecord"
            class="error"
            :disabled="selected.length==0"
          >Suppress Entries</v-btn>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </template>

        <template v-slot:item="{item, index, headers, isSelected, select}">
          <!-- <template slot="items" slot-scope="props"> -->
          <tr @click.left.exact="selectRecord(item) " @click.left.shift.prevent="selectMulti(item)">
            <td v-show="selection">
              <v-simple-checkbox color="red" :value="isSelected" @input="selectRecord(item)"></v-simple-checkbox>
            </td>
            <td
              :class="`text-xs-${name.align}`"
              v-for="(name, index) in headers.filter(x => x.value !== 'data-table-select')"
              :name="name"
              :key="index"
            >
              <span
                v-if="name.value.toLowerCase() === 'datesuppressed'"
              >{{getDeletedorSupressed(item[name.value])}}</span>
              <span v-else-if="item[name.value] === '1900-01-01T00:00:00+10:00'"></span>
              <span
                v-else-if="name.value.toLowerCase() === 'returnresult'"
              >{{getReturnResult(item[name.value])}}</span>
              <span
                v-else-if="name.value.toLowerCase().includes('date')"
              >{{item[name.value] | formatDate}}</span>
              <span
                v-else-if="name.text.toLowerCase().includes('$')"
              >${{item[name.value] | formatMoney}}</span>

              <span v-else>{{item[name.value] }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from "moment";
export default {
  props: {
    customers: Array,
    headers: Array,
    selection: Boolean
  },
  data () {
    return {
      loading: false,
      search: "",
      selected: [],
      currentRow: undefined
    };
  },
  methods: {
    refresh () {
      this.$emit("refresh");
    },
    deleteRecord () {
      this.$emit("deleteRecord", this.selected);
    },
    suppressRecord () {
      this.$emit("suppressRecord", this.selected);
    },
    selectRecord (item) {
      this.currentRow = this.customers.indexOf(item);
      let found = this.selected.indexOf(item);
      if (found < 0) this.selected.push(item);
      else this.selected.splice(found, 1);
    },
    selectMulti (item) {
      let endRow = this.customers.indexOf(item);
      for (let index = this.currentRow + 1; index <= endRow; index++) {
        let found = this.selected.indexOf(this.customers[index]);
        if (found < 0) this.selected.push(this.customers[index]);
        else this.selected.splice(found, 1);
      }
    },
    getDeletedorSupressed (value) {
      if (value === "0001-01-01T00:00:00+10:00") return "Deleted";
      else return moment(String(value)).format("DD/MM/YYYY");
    },
    getReturnResult (value) {
      switch (value) {
        case 0:
          return "Not Sent";
        case 1:
          return 'Approved';
        case 2:
          return "Sent";
        case 3:
          return "Rejected";
        case 4:
          return "Accepted";
      }
    }
  }
};
</script>